import "../styles/global.css";
import Layout from "@/components/layout";
import { AnimatePresence, m } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
import { ManagedUIContext } from "@/contexts/ui.context";
import ManagedDrawer from "@/components/drawer/managed-drawer";
import { DefaultSeo } from "next-seo";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleAnalytics } from "@next/third-parties/google";
function MyApp({ Component, pageProps: { ...pageProps }, router }) {
  return (
    <AnimatePresence>
      <ManagedUIContext>
        <LazyMotion features={domAnimation}>
          <DefaultSeo
            title="Rose Bowl | Shop Now"
            defaultTitle="Rose Bowl | Shop Now"
            description="Explore Our Glassworks. Browse our exclusive range of handcrafted glass platters and T-lights to illuminate your spaces."
            canonical="https://www.rosebowl.in/"
            openGraph={{
              url: "https://www.rosebowl.in/",
              title: "Rose Bowl",
              description:
                "Explore Our Glassworks. Browse our exclusive range of handcrafted glass platters and T-lights to illuminate your spaces.",
              images: [
                {
                  url: "https://www.rosebowl.in/images/rosebowl-logo-512x512.webp",
                  width: 140,
                  height: 140,
                  alt: "Rose Bowl",
                },
              ],
            }}
            twitter={{
              // handle: "@avneesh0612",
              // site: "@avneesh0612",
              cardType: "summary_large_image",
            }}
            additionalLinkTags={[
              {
                rel: "icon",
                href: `/favicon.ico`,
              },
            ]}
          />
          <Layout>
            <GoogleAnalytics gaId="G-TYHWD7V2L6" />
            <m.div
              key={router.route}
              initial={{ opacity: 0 }}
              animate={{ opacity: 100, transition: { duration: 0.35 } }}
              exit={{ opacity: 0 }}
              className="h-auto w-full"
            >
              <Component {...pageProps} key={router.route} />
            </m.div>
            <ToastContainer />
            <ManagedDrawer />
          </Layout>
        </LazyMotion>
      </ManagedUIContext>
    </AnimatePresence>
  );
}

export default MyApp;
